import { Typography } from '@mui/material';
import { Tooltip } from 'src/components';

export const TextCell = ({ text, textColor }: { text: string; textColor?: string }) => {
  if (typeof text !== 'string') {
    return text;
  }

  return (
    <Tooltip title={text} enterDelay={1000}>
      <Typography
        variant="body2"
        sx={{
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          ...(textColor ? { color: textColor } : {}),
        }}
        component="span"
      >
        {text}
      </Typography>
    </Tooltip>
  );
};
